import _regeneratorRuntime from '@babel/runtime-corejs3/helpers/esm/regeneratorRuntime';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/esm/asyncToGenerator';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import { useRef, useEffect } from 'react';
import { isElementVisible } from './useIsElementVisible.js';
import { scrollToElement } from './useScrollToItem.js';

var useScrollToPreSelectedItem = function useScrollToPreSelectedItem(children, direction, layout) {
  var containerRef = useRef(null);
  useEffect(function () {
    if (layout !== 'scroll') return;
    var preSelectedElement = children === null || children === void 0 ? void 0 : _findInstanceProperty(children).call(children, function (child) {
      return child.props.isSelected;
    });
    if (!preSelectedElement) return;
    var element = document.querySelector('[aria-checked="true"]');
    if (!element) return;
    var checkVisibility = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var isVisible, scrollDirection;
        return _regeneratorRuntime().wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return isElementVisible(element);
            case 1:
              isVisible = _context.sent;
              if (!isVisible) {
                scrollDirection = direction === 'vertical' ? 'vertical' : 'horizontal';
                scrollToElement(containerRef, {
                  current: element
                }, scrollDirection);
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function checkVisibility() {
        return _ref.apply(this, arguments);
      };
    }();
    checkVisibility();
  }, [children, direction, layout]);
  return containerRef;
};

export { useScrollToPreSelectedItem };
//# sourceMappingURL=useScrollToPreSelectedItem.js.map
